var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCashDollar = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31649_31883)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C3.5888 16 0 12.4112 0 8C0 3.5888 3.5888 0 8 0C12.4112 0 16 3.5888 16 8C16 12.4112 12.4112 16 8 16ZM8.8 4C8.8 3.55817 8.44183 3.2 8 3.2C7.55817 3.2 7.2 3.55817 7.2 4V4.13648C6.2677 4.46583 5.6 5.3547 5.6 6.4C5.6 7.21075 5.88783 7.81587 6.42 8.215C6.85221 8.53916 7.39179 8.6732 7.75309 8.76295L7.80597 8.77611C8.24608 8.88614 8.47385 8.95539 8.62 9.065C8.68783 9.11587 8.8 9.21075 8.8 9.6C8.8 10.0378 8.44921 10.3929 8.01309 10.3999C8.00626 10.3993 7.99355 10.3981 7.97564 10.3955C7.93017 10.389 7.85249 10.3742 7.75298 10.3411C7.55675 10.2756 7.26796 10.1366 6.96569 9.83432C6.65327 9.5219 6.14673 9.5219 5.83431 9.83432C5.5219 10.1467 5.5219 10.6533 5.83431 10.9657C6.31292 11.4443 6.80398 11.704 7.2 11.8429V12C7.2 12.4418 7.55817 12.8 8 12.8C8.44183 12.8 8.8 12.4418 8.8 12V11.8635C9.7323 11.5342 10.4 10.6453 10.4 9.6C10.4 8.78925 10.1122 8.18413 9.58 7.785C9.14779 7.46084 8.60822 7.3268 8.24692 7.23705L8.19403 7.22389C7.75392 7.11386 7.52615 7.04462 7.38 6.935C7.31217 6.88413 7.2 6.78925 7.2 6.4C7.2 5.9622 7.55079 5.60708 7.98691 5.6001C7.99374 5.60066 8.00645 5.6019 8.02436 5.60446C8.06983 5.61095 8.14751 5.62578 8.24702 5.65895C8.44325 5.72436 8.73205 5.86342 9.03432 6.16569C9.34674 6.47811 9.85327 6.47811 10.1657 6.16569C10.4781 5.85327 10.4781 5.34673 10.1657 5.03431C9.68708 4.55571 9.19602 4.29605 8.8 4.15714V4Z",
    fill: "#5C5F62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31649_31883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCashDollar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cash-dollar.c035a6de.svg";
export { ForwardRef as ReactComponent };